'use client';
import React from 'react';
import Image from 'next/image';
import { useRouter } from 'next/navigation';
import { useChatStore } from '@/store/chatStore';

const Header: React.FC = () => {
  const router = useRouter();
  const { setMessages } = useChatStore();

  const handleLogoClick = () => {
    // Reset chat messages
    setMessages([]);
    // Navigate to home page
    router.push('/');
  };

  return (
    <header className="fixed top-0 left-0 p-4 sm:p-6 z-50">
      <button 
        onClick={handleLogoClick}
        className="bg-white rounded-full shadow-md px-4 py-2 flex items-center hover:bg-gray-50 transition-colors duration-200"
        aria-label="Retour à l'accueil"
      >
        <Image
          src="/assets/images/logo-veolia.svg"
          alt="Logo Veolia"
          width={92}
          height={23}
          loading="lazy"
        />
      </button>
    </header>
  );
};

export default Header;